// src/components/settings/Sidebar.jsx
import React from "react";
import { Card } from "react-bootstrap";
import { FiChevronRight } from "react-icons/fi";

const tabs = [
  "Business Settings",
  "SEO Settings",
  "Localization",
  "Prefixes",
  "Preferences",
  "Appearance",
  "Language",
  "Authentication Settings",
  "AI Settings",
];

export default function Sidebar({ activeTab, setActiveTab }) {
  return (
    <Card className="sidebar-card mb-3">
      <Card.Body className="p-2">
        {tabs.map((tab, i) => (
          <div
            key={i}
            className={`sidebar-item ${
              activeTab === tab ? "active" : ""
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {activeTab === tab && <FiChevronRight />}
            {tab}
          </div>
        ))}
      </Card.Body>
    </Card>
  );
}